'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.LocaleSwitcher = exports.LocaleSwitcherUnwrapped = undefined;

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactIntl = require('react-intl');

var _multitrack = require('helpers/multitrack');

var _supportedLocales = require('locales/supported-locales.json');

var _supportedLocales2 = _interopRequireDefault(_supportedLocales);

var _env = require('helpers/env');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var languageNames = {
  'fr-FR': 'Français',
  'en-US': 'English (United States)',
  'en-AU': 'English (Australia)',
  'de-DE': 'Deutsche'
};

var LocaleSwitcherUnwrapped = exports.LocaleSwitcherUnwrapped = function (_React$Component) {
  (0, _inherits3.default)(LocaleSwitcherUnwrapped, _React$Component);

  function LocaleSwitcherUnwrapped() {
    (0, _classCallCheck3.default)(this, LocaleSwitcherUnwrapped);
    return (0, _possibleConstructorReturn3.default)(this, (LocaleSwitcherUnwrapped.__proto__ || (0, _getPrototypeOf2.default)(LocaleSwitcherUnwrapped)).apply(this, arguments));
  }

  (0, _createClass3.default)(LocaleSwitcherUnwrapped, [{
    key: 'localeClicked',
    value: function localeClicked(locale) {
      (0, _multitrack.ga)('Locale Switched', 'Changed', locale);
      document.cookie = 'locale=' + locale;
      window.location.reload();
    }
  }, {
    key: 'locales',
    value: function locales() {
      return _supportedLocales2.default;
    }
  }, {
    key: 'render',
    value: function render() {
      var _this = this;

      var _props = this.props,
          currentLocale = _props.intl.locale,
          className = _props.className,
          children = _props.children;


      var locales = this.locales();

      if (locales.length === 0 || (0, _env.isProduction)()) {
        return null;
      }

      return _react2.default.createElement(
        'ul',
        { className: className },
        locales.map(function (locale) {
          return children({
            selected: currentLocale === locale,
            name: languageNames[locale],
            locale: locale,
            onClick: _this.localeClicked.bind(_this, locale)
          });
        })
      );
    }
  }]);
  return LocaleSwitcherUnwrapped;
}(_react2.default.Component);

LocaleSwitcherUnwrapped.defaultProps = {
  className: 'LocaleSwitcher',
  children: function children(_ref) {
    var locale = _ref.locale,
        selected = _ref.selected,
        onClick = _ref.onClick,
        name = _ref.name;
    return _react2.default.createElement(
      'li',
      {
        key: locale,
        className: selected ? 'selected' : null,
        onClick: onClick
      },
      name
    );
  }
};

LocaleSwitcherUnwrapped.propTypes = {
  intl: _reactIntl.intlShape.isRequired,
  className: _propTypes2.default.string,
  children: _propTypes2.default.func
};

var LocaleSwitcher = exports.LocaleSwitcher = (0, _reactIntl.injectIntl)(LocaleSwitcherUnwrapped);